import React, { forwardRef } from 'react'
import { Grid } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import UiSwitch from "../../../../_uiMocks/_uiComponents/UiSwitch"
import UiInput from '../../../../_uiMocks/_uiComponents/UiInput';
import UiSelect from "../../../../_uiMocks/_uiComponents/UiSelect"
import { UiButton, UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../_uiComponents/common/UiInnerSearchWr';
import UiLookUpDataInputWr from '../../../_uiComponents/dataManagement/LookupDataInputWr';
import UiTagsInput from '../../../../_uiMocks/_uiComponents/UiTagsInput'

export default function CreateLookUpTableForm() {

    const [contains, setContains] = React.useState('');
    let navigate = useNavigate();

    const handleContainChange = (event) => {
        setContains(event.target.value);
    };

    const handleClick = () => {
        //  clear input value
        setContains('');
    };

    const handleSelecetedTags = (items) => {
        console.log(items);
    }
    const options = [
        { value: 'value-1', label: 'text-1' },
        { value: 'value-2', label: 'text-2' },
        { value: 'value-3', label: 'text-3' }
    ];

    return (
        <>
            <UiInnerSearchWr>
                <Grid container spacing={2}>
                    <UiLookUpDataInputWr>

                        <Grid container spacing={2}>
                            <Grid item xs={12} lg={6} >
                                <UiInput type="text" label="Name" />
                            </Grid>
                            <Grid item xs={12} lg={6} >
                                <UiSelect label="Type"
                                    value={contains}
                                    handleChange={handleContainChange}
                                    options={options} />

                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <UiTagsInput selectedTags={handleSelecetedTags}
                                    fullWidth
                                    variant="outlined"
                                    id="labels"
                                    name="labels"
                                    label="Labels" />
                            </Grid>
                            <FormControlLabel control={
                                <UiSwitch />}
                                    label="Active"
                                    labelPlacement="top"
                                    sx={{ mt: 2 }}
                                    className='sba-switch-label' />
                        </Grid>

                    </UiLookUpDataInputWr>

                    <Grid item xs={12}>
                        <Stack spacing={2} direction="row" justifyContent="space-between" alignItems={"center"} sx={{ width: '100%' }}>
                            <UiBackButton size="small" onClick={() => navigate(-1)} />
                            <div className='sbt-right-action-btn-wr'>
                                <UiButton onClick={handleClick} name="Clear" variant="outlined" size="small" />
                                <UiButton name="Update" variant="contained" size="small" />
                            </div>
                        </Stack>
                    </Grid>
                </Grid>
            </UiInnerSearchWr>


        </>
    )
}
